export const PK_LIST = 'PK_LIST'; // 初始盘库列表
export const CHANGE_PK_LIST = 'CHANGE_PK_LIST'; // 修改盘库单中某一列的值
export const CONFIRM_PK_LIST = 'CONFIRM_PK_LIST'; // 确认盘库列表
export const SET_PK_ID = 'SET_PK_ID'; // 盘库ID
export const SET_PK_CODE = 'SET_PK_CODE'; // 盘库单号
export const SET_TC_ID = 'SET_TC_ID'; // 盘库单号
export const SET_ACC_INFO = 'SET_ACC_INFO'; // 记住密码
export const SET_SHOW_KC = 'SET_SHOW_KC'; // 记住密码
export const SET_STOCK_OUT_CONDITION = 'SET_STOCK_OUT_CONDITION'; // 出库分页
export const SET_STOCK_IN_CONDITION = 'SET_STOCK_IN_CONDITION'; // 出库分页
export const SET_SALE_PRICING_CONDITION = 'SET_SALE_PRICING_CONDITION';
// 进销存
export const SET_DEPOSIT_DATA_CONDITION = 'SET_DEPOSIT_DATA_CONDITION';
// -----------------------------------结算管理
// -----------------------------------自录客户
export const SET_NEW_ORDER_SEARCH_DATA_CONDITION = 'SET_NEW_ORDER_SEARCH_DATA_CONDITION';
// -----------------------------------供应商结算
export const SET_READY_SEARCH_DATA_CONDITION = 'SET_READY_SEARCH_DATA_CONDITION';
// -----------------------------------团餐客户
export const SET_ORDER_LIST_SEARCH_CONDITION = 'SET_ORDER_LIST_SEARCH_CONDITION';
// ----------------------------------结算列表
// ----------------------------------自录客户结算列表
export const SET_ORDER_LIST_CONDITION = 'SET_ORDER_LIST_CONDITION';
// ----------------------------------团餐结算列表
export const SET_TC_ORDER_LIST_CONDITION = 'SET_TC_ORDER_LIST_CONDITION';
// ----------------------------------供应商结算列表
export const SET_GYS_ORDER_LIST_CONDITION = 'SET_GYS_ORDER_LIST_CONDITION';

// ----------------------------销售订单
export const SET_ENTRY_SEARCH_DATA_CONDITION = 'SET_ENTRY_SEARCH_DATA_CONDITION';
// ----------------------------销售订单--待确认
export const SET_XMD_CONFIRM_SEARCH_DATA_CONDITION = 'SET_XMD_CONFIRM_SEARCH_DATA_CONDITION';
export const SET_CONFIRM_SEARCH_DATA_CONDITION = 'SET_CONFIRM_SEARCH_DATA_CONDITION';
// ----------------------------销售订单--历史
export const SET_HISTORY_SEARCH_DATA_CONDITION = 'SET_HISTORY_SEARCH_DATA_CONDITION';

export const SET_SAVE_OTHER_PANENAME = 'SET_SAVE_OTHER_PANENAME';

// ----------------------------销售订单--全部
export const SET_ALL_SEARCH_DATA_CONDITION = 'SET_ALL_SEARCH_DATA_CONDITION';

// ----------------------------销售订单--订单查询
export const SET_SERACH_SELL_ORDER_DATA_CONDITION = 'SET_SERACH_SELL_ORDER_DATA_CONDITION';
// ----------------------------采购订单--待送
export const SET_NEWORDER_SEARCH_DATA_CONDITION = 'SET_NEWORDER_SEARCH_DATA_CONDITION';
// ----------------------------采购订单--历史
export const SET_NEWORDER_HISTORY_DATA_CONDITION = 'SET_NEWORDER_HISTORY_DATA_CONDITION';

// ----------------------------报表--出库单
export const SET_HISTORY_OUT_DATA_CONDITION = 'SET_HISTORY_OUT_DATA_CONDITION';
export const SET_HISTORY_IN_DATA_CONDITION = 'SET_HISTORY_IN_DATA_CONDITION';

// -----------------------------没用
// ----------------------------销售订单----新增产品
export const SET_NEW_ADD_ORDER_CONDITION = 'SET_NEW_ADD_ORDER_CONDITION';

// ----------------------------供应商管理----新增产品
export const SET_GYS_ADD_ORDER_CONDITION = 'SET_GYS_ADD_ORDER_CONDITION';

// ----------------------------采买单
export const SET_CMD_INFO_CONDITION = 'SET_CMD_INFO_CONDITION';
// ----------------保存面板状态
export const SET_SAVE_PANENAME = 'SET_SAVE_PANENAME';
export const SET_SAVE_STOCKLIST = 'SET_SAVE_STOCKLIST';
export const SET_SAVE_DSORDER_LIST = 'SET_SAVE_DSORDER_LIST';
export const SET_SAVE_QUALIFIC_LIST = 'SET_SAVE_QUALIFIC_LIST';

// 销售报表---》时间
export const TAB_SALES_DATE = 'TAB_SALES_DATE';

// 销售订单 ----》打印标签
export const S_PRINT_ALL = 'S_PRINT_ALL';

// 报表 -------》每日剩余库存表
export const DAILYINVENTORY_ALL = 'DAILYINVENTORY_ALL';
// 报表 -------》盘库盈亏表
export const PROFITLOSSTABLE_ALL = 'PROFITLOSSTABLE_ALL';

// 报表 -------》销售退库单
export const RETURNWAREHOUSE_ALL = 'RETURNWAREHOUSE_ALL';

// 报表 -------》销售退货单
export const RETURNGOODS_ALL = 'RETURNGOODS_ALL';

// 报表 -------》采购退货单
export const RETURNPRODUCT_ALL = 'RETURNPRODUCT_ALL';

// 报表 -------》销售报表
export const SALESSTATEMENTS_ALL = 'SALESSTATEMENTS_ALL';

// 报表 -------》毛利报表
export const GROSSPROFIT_ALL = 'GROSSPROFIT_ALL';

// 报表 -------》采购报表
export const PURCHASE_ALL = 'PURCHASE_ALL';

// 报表 -------》进销存报表
export const TOTALDEPOSITPURCHASE_ALL = 'TOTALDEPOSITPURCHASE_ALL';

// 报表 -------》客户毛利表
export const TCGROSSPROFIT_ALL = 'TCGROSSPROFIT_ALL';

// 报表 -------》销售退货单
export const SELLORDERRETURN_ALL = 'SELLORDERRETURN_ALL';

// 报表 -------》采购价格变化趋势
export const PRICECHANGECHART_ALL = 'PRICECHANGECHART_ALL';

// 报表 -------》商品销售排行
export const PRODUCTRANKLIST_ALL = 'PRODUCTRANKLIST_ALL';

// 报表 -------》总仓单品毛利表
export const SINGLERANGE_ALL = 'SINGLERANGE_ALL';


// --------------------------------------采买单
export const SET_PURCHASE_SEARCH = 'SET_PURCHASE_SEARCH';
// --------------------------------------分菜单管理
export const SET_SORT_SEARCH = 'SET_SORT_SEARCH';

// -------------------------------------------------------领料单
export const SET_SAVE_PICKING_DOC = 'SET_SAVE_PICKING_DOC';

// ---------------------------------------------生产领料单
export const SET_SAVE_PRO_PICKING_DOC = 'SET_SAVE_PRO_PICKING_DOC';

// ---------------------------------------------生产入库
export const SET_SAVE_PRO_WAREHOUSING = 'SET_SAVE_PRO_WAREHOUSING';

// ---------------------------------------------生产入库单
export const SET_SAVE_PRO_RECEIPT = 'SET_SAVE_PRO_RECEIPT';

// --------------------------------------------客户列表
export const SET_SAVE_CUSTOMER_LIST = 'SET_SAVE_CUSTOMER_LIST';
// ---------------------------------------------供应商列表
export const SET_SUPPLIER_LIST = 'SET_SUPPLIER_LIST';
// -----------------------------------------------生产配置管理
export const SET_PRODUCTION_LIST = 'SET_PRODUCTION_LIST';
// -----------------------------------------------出库汇总单
export const SET_TOTAL_OUT_DOC_LIST = 'SET_TOTAL_OUT_DOC_LIST';
// 仓库管理->盘库筛选条件记录
export const SET_INVENTORY_SEARCH = 'SET_INVENTORY_SEARCH';

// 人员管理
export const SET_PERSON_MANAGE_DATA_CONDITION = 'SET_PERSON_MANAGE_DATA_CONDITION';
// 库位
export const SET_POSITION_CONDITION = 'SET_POSITION_CONDITION';
// 一类
export const SET_FIRST_CATEGORY_DATA_CONDITION = 'SET_FIRST_CATEGORY_DATA_CONDITION';
// 二类
export const SET_SECOND_CATEGORY_DATA_CONDITION = 'SET_SECOND_CATEGORY_DATA_CONDITION';
// 在用SKU
export const SET_SKU_USED_DATA_CONDITION = 'SET_SKU_USED_DATA_CONDITION';

// 检验是否从新增按钮进入购物车
export const SET_ADD_BTN_TO_PROJECT = 'SET_ADD_BTN_TO_PROJECT';

// 采购订单待确认订单
export const SET_CONFIRM_DATA_CONDITION = 'SET_CONFIRM_DATA_CONDITION';
export const SET_CONFIRM_DATA_CONDITION_S = 'SET_CONFIRM_DATA_CONDITION_S';

// WMS-临时仓
export const SET_WMS_TEMPORARYSTOCK_CONDITION = 'SET_WMS_TEMPORARYSTOCK_CONDITION';
// WMS-库存预警
export const SET_WMS_STOCKWARNING_CONDITION = 'SET_WMS_STOCKWARNING_CONDITION';
// 拣货单界面
export const SET_PICKINGLIST_CONDITION = 'SET_PICKINGLIST_CONDITION';
// 价格管理-客户定价复核
export const SET_CUSTOMER_PRICING_REVIEW_CONDITION = 'SET_CUSTOMER_PRICING_REVIEW_CONDITION';
// 销售订单管理-销售价复核
export const SET_SALES_PRICE_REVIEW_CONDITION = 'SET_SALES_PRICE_REVIEW_CONDITION';
// 产品管理-产品税率-供应商税率设置
export const SET_SUPPLIERTAX_DATA_CONDITION = 'SET_SUPPLIERTAX_DATA_CONDITION';
// 报表-送货差异表
export const SET_DELIVERY_DISCREPANCY_DATA_CONDITION = 'SET_DELIVERY_DISCREPANCY_DATA_CONDITION';
// 分拣配送-分拣组管理
export const SET_SORTING_GROUP_MANAGEMENT_CONDITION = 'SET_SORTING_GROUP_MANAGEMENT_CONDITION';
// 财务中心-发票列表
export const SET_INVOICE_LIST_DATA_CONDITION = 'SET_INVOICE_LIST_DATA_CONDITION';
// 分拣配送-周转筐管理
export const SET_TURNOVER_MANAGE_DATA_CONDITION = 'SET_TURNOVER_MANAGE_DATA_CONDITION';
// 价格管理-销售价格查询
export const SET_SALES_PRICE_INQUIRY_CONDITION = 'SET_SALES_PRICE_INQUIRY_CONDITION';
// 价格管理-采购价格查询
export const SET_PURCHASE_PRICE_INQUIRY_CONDITION = 'SET_PURCHASE_PRICE_INQUIRY_CONDITION';
// 第三方配送订单-转换订单
export const SET_SUPPLIER_SEND_ORDER_CONDITION = 'SET_SUPPLIER_SEND_ORDER_CONDITION';
// 第三方配送订单-历史订单
export const SET_DSHISTORY_ORDER_LIST_CONDITION = 'SET_DSHISTORY_ORDER_LIST_CONDITION';
// 第三方配送订单-待送订单
export const SET_DS_ORDER_LIST_CONDITION = 'SET_DS_ORDER_LIST_CONDITION';
// 第三方配送订单-待确认订单
export const SET_DS_ORDER_CONFIRM_LIST_CONDITION = 'SET_DS_ORDER_CONFIRM_LIST_CONDITION';
// 食品安全-采购品资质下载
export const SET_PURCHASE_QUALIFICATION_DOWNLOAD_LIST = 'SET_PURCHASE_QUALIFICATION_DOWNLOAD_LIST';
// 食品安全-采购品资质下载详情
export const SET_PURCHASE_QUALIFICATION_DOWNLOAD_DETAIL_LIST = 'SET_PURCHASE_QUALIFICATION_DOWNLOAD_DETAIL_LIST';
// 报表-业务部毛利表
export const SET_BUSINESS_GROSS_PROFIT_TABLE = 'SET_BUSINESS_GROSS_PROFIT_TABLE';
// 报表-仓库收发明细表
export const SET_WAREHOUSE_TRANSCEIVER_CONDITION = 'SET_WAREHOUSE_TRANSCEIVER_CONDITION';
// 报表-采购部差价表
export const SET_PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION = 'SET_PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION';
// 销售订单管理-订单调价申请记录
export const SET_PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION = 'SET_PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION';



export const SET_STOCK_ENTER_DETAIL = 'SET_STOCK_ENTER_DETAIL';
export const SET_DS_UNPRICE_ORDER_DETAIL_CONDITION = 'SET_DS_UNPRICE_ORDER_DETAIL_CONDITION';



//////////////////
// WEBPACK FOOTER
// ./store/mutation-type.js
// module id = null
// module chunks = 